import { useState, useEffect } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";

const navItems = [
  { to: "/", label: "ANA SAYFA", testid: "nav-home" },
  { to: "/sifir-motorlar", label: "SIFIR MOTORLAR", testid: "nav-sifir" },
  { to: "/ikinci-el-motorlar", label: "İKİNCİ EL MOTORLAR", testid: "nav-ikinci-el" },
  { to: "/ikinci-el-araclar", label: "İKİNCİ EL ARAÇLAR", testid: "nav-araclar" },
  { to: "/hakkimizda", label: "HAKKIMIZDA", testid: "nav-about" },
  { to: "/randevu", label: "SERVİS RANDEVU", testid: "nav-appointment" },
  { to: "/iletisim", label: "İLETİŞİM", testid: "nav-contact" },
];

const Header = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-black/90 backdrop-blur-xl border-b border-zinc-900" : "bg-gradient-to-b from-black/70 to-transparent"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 flex items-center justify-between h-20">
        <Link to="/" data-testid="header-logo" className="flex items-center group">
          <img src="/gensan-logo-full.png" alt="Gensan Motors" className="h-14 md:h-16 w-auto object-contain" />
        </Link>

        <nav className="hidden lg:flex items-center gap-1">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              data-testid={item.testid}
              className={({ isActive }) =>
                `relative px-4 py-2 text-sm font-semibold uppercase tracking-widest transition-colors ${
                  isActive ? "text-orange-500" : "text-zinc-300 hover:text-white"
                }`
              }
            >
              {({ isActive }) => (
                <>
                  {item.label}
                  {isActive && (
                    <span className="absolute -bottom-1 left-4 right-4 h-0.5 bg-orange-500" />
                  )}
                </>
              )}
            </NavLink>
          ))}
        </nav>

        <Link
          to="/iletisim"
          data-testid="header-cta-button"
          className="hidden lg:inline-flex items-center bg-orange-600 hover:bg-orange-700 text-white px-6 py-3 font-bold uppercase tracking-widest text-xs transition-colors"
        >
          Bize Ulaş
        </Link>

        <button
          data-testid="mobile-menu-toggle"
          onClick={() => setOpen(!open)}
          className="lg:hidden text-white p-2"
          aria-label="Menüyü aç"
        >
          {open ? <X size={28} /> : <Menu size={28} />}
        </button>
      </div>

      {/* Mobile Menu */}
      <div
        data-testid="mobile-menu"
        className={`lg:hidden bg-black border-t border-zinc-900 overflow-hidden transition-all duration-300 ${
          open ? "max-h-[500px]" : "max-h-0"
        }`}
      >
        <nav className="flex flex-col p-6 gap-2">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              data-testid={`mobile-${item.testid}`}
              className={({ isActive }) =>
                `px-4 py-3 text-base font-semibold uppercase tracking-widest border-l-2 transition-colors ${
                  isActive
                    ? "text-orange-500 border-orange-500"
                    : "text-zinc-300 border-transparent hover:border-zinc-700 hover:text-white"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
          <Link
            to="/iletisim"
            data-testid="mobile-cta-button"
            className="mt-3 inline-flex items-center justify-center bg-orange-600 hover:bg-orange-700 text-white px-6 py-4 font-bold uppercase tracking-widest text-sm transition-colors"
          >
            Bize Ulaş
          </Link>
        </nav>
      </div>
    </header>
  );
};

export default Header;
